export default "__VITE_ASSET__871e4fb7__"